"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScopedThemeProps = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("../context/constants");
var _context = require("../context");
const getScopedThemeProps = _ref => {
  let {
    scopeId,
    isInvertedColorScheme
  } = _ref;
  let resultProps = {};
  if (isInvertedColorScheme) {
    resultProps = {
      [_utils.PREFERS_COLOR_SCHEME_ID]: _context.ThemeMode.Dark
    };
  }
  if (scopeId) {
    return {
      ...resultProps,
      [_constants.THEME_SCOPE_ID]: scopeId
    };
  }
  return resultProps;
};
exports.getScopedThemeProps = getScopedThemeProps;